const expense = {
  path: '/expense',
  name: 'expense',
  component: () =>
    import(
      /* webpackChunkName: "expense" */ '@/components/expense/ExpenseIndex.vue'
    ),
  children: [
    {
      path: 'view/:id',
      component: () =>
        import(
          /* webpackChunkName: "expense" */ '@/components/expense/ExpenseView.vue'
        ),
      name: 'expenseView',
    },
    {
      path: 'edit/:id',
      component: () =>
        import(
          /* webpackChunkName: "expense" */ '@/components/expense/ExpenseEdit.vue'
        ),
      name: 'expenseEdit',
    },
    {
      path: 'create',
      component: () =>
        import(
          /* webpackChunkName: "expense" */ '@/components/expense/ExpenseCreate.vue'
        ),
      name: 'expenseCreate',
    },
  ],
  meta: { authorize: [], requiresAuth: true },
};

export default expense;
